export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_10.363589a5.jpg";